import { render, staticRenderFns } from "./ThankYouLayoutSpaceship.vue?vue&type=template&id=8650a5b8&"
import script from "./ThankYouLayoutSpaceship.vue?vue&type=script&lang=js&"
export * from "./ThankYouLayoutSpaceship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports